import React from "react";
import { WarningCircle } from "@phosphor-icons/react";

// Shared "Perché / Cosa fare / Attenzione" block used by every task-detail
// panel in the app (Organizza la partenza + Scuola USA operativa).
// Kept as a standalone component so visual tweaks propagate everywhere at
// once. Labels come from the caller (already localized) so we don't depend
// on i18n context here.
export default function TaskDetailsPanel({
  why, how, careful,
  whyLabel = "Perché",
  howLabel = "Cosa fare",
  carefulLabel = "Attenzione",
  className = "",
}) {
  if (!why && !how && !careful) return null;
  return (
    <div className={`space-y-3 ${className}`}>
      {why && (
        <div>
          <div className="text-[11px] uppercase tracking-widest font-sans font-bold text-terracotta">
            {whyLabel}
          </div>
          <p className="text-sm text-ink leading-relaxed mt-1 font-sans">{why}</p>
        </div>
      )}
      {how && (
        <div>
          <div className="text-[11px] uppercase tracking-widest font-sans font-bold text-sage">
            {howLabel}
          </div>
          <p className="text-sm text-ink leading-relaxed mt-1 font-sans">{how}</p>
        </div>
      )}
      {careful && (
        <div>
          <div className="text-[11px] uppercase tracking-widest font-sans font-bold text-ink-soft flex items-center gap-1">
            <WarningCircle size={13} weight="duotone" className="text-terracotta" />
            {carefulLabel}
          </div>
          <p className="text-sm text-ink leading-relaxed mt-1 font-sans">{careful}</p>
        </div>
      )}
    </div>
  );
}
